import { ButtonSize } from '@nextgen-web-framework/all';
import { SubCarts } from '@commerce-cart-webcomponents/sdk';
import { BundleSlot, SubscriptionResponse } from '@commerce-subscription-webcomponents/sdk';
import { ProductListType } from '../../../subscription-plan/basketsize-template/types/propTypes';

export interface SubscribeButtonPropTypes {
  productId: string;
  quantity?: number;
  productType?: string;
  dataFlow?: DataFlowEnum;
  disabled?: boolean;
  size?: ButtonSize;
  bundleSlots?: BundleSlot[];
  productList?: Array<ProductListType>;
  isBasketSizePlan?: boolean;
  onSuccess?: (event: SubscribeEventPaylod) => void;
  detailsForCartApiCall?: {
    enableGroupOrder: boolean;
    isCartPresent: boolean;
    cartId: string;
    cartVersion: number;
    subCart?: SubCarts;
    currentOrderType: string;
    addToCart: (subscriptionDetails: SubscriptionResponse) => Promise<void>;
    createCart: (subscriptionDetails: SubscriptionResponse) => Promise<void>;
  };
}

export interface SubscribeEventPaylod {
  productId?: string;
  planId?: string;
  subscriptionId?: string;
}

export enum DataFlowEnum {
  PDP = 'PDP',
  CHECKOUT = 'CHECKOUT',
  PLAN_DETALS = 'PLAN_DETALS',
  RETRY = 'RETRY',
}

export enum AllowedType {
  MANUAL = 'MANUAL',
  AUTOMATIC = 'AUTOMATIC',
  BOTH = 'BOTH',
}
